import { useQuery } from "@tanstack/react-query";
import { DashboardService } from "../services/dashboard.service";

export const useGetDashboardStatsHook = () => {
  return useQuery({
    queryKey: ["dashboard", "stats"],
    queryFn: () => DashboardService.getStats(),
  });
};
